import React from 'react';

import { designTokens, Typography } from '@project44/manifest-ds';

import Check from '../../resources/Check_small.svg';
import Ellipse from '../../resources/Ellipse.svg';
import Fail from '../../resources/Fail.svg';

const { spaceSmall } = designTokens;
type SetPasswordInstructionType = {
  message: string;
  errorState: string;
};

const { colorTextSecondary, colorTextSuccess, colorTextDanger } = designTokens;
const fetchIcon = (errorState: string) => {
  switch (errorState) {
    case 'unknown':
      return { icon: Ellipse, color: colorTextSecondary };
    case 'pass':
      return { icon: Check, color: colorTextSuccess };
    case 'fail':
      return { icon: Fail, color: colorTextDanger };
    default:
      return { icon: Ellipse, color: colorTextSecondary };
  }
};

const SetPasswordInstruction = ({
  message,
  errorState,
}: SetPasswordInstructionType) => {
  return (
    <>
      <Typography
        variant="caption"
        css={{ color: fetchIcon(errorState).color }}
      >
        <img
          src={fetchIcon(errorState).icon}
          style={{ marginRight: spaceSmall }}
        />
        {message}
        <br />
      </Typography>
    </>
  );
};

export default SetPasswordInstruction;
